import axios from 'axios';

/*SoNo User API Authentication with JWT and Axios*/

console.log("NODE_ENV: ",process.env.NODE_ENV);
console.log("process.env.VUE_APP_API_ENDPOINT: ",process.env.VUE_APP_API_ENDPOINT);

const HTTP = axios.create({
    baseURL: process.env.VUE_APP_API_ENDPOINT,
    //baseURL: 'http://localhost:3000'
    //baseURL: 'https://truecon.dev.cluevo.at'
})

const HTTPGEO = axios.create({
    baseURL: 'https://api.bigdatacloud.net/data/',
})

const HTTPFILE = axios.create({
    baseURL: process.env.VUE_APP_FILEAPI_ENDPOINT,
})

export default HTTP;
export {HTTPGEO, HTTP, HTTPFILE};